import { FEATURE_FLAGS } from "@/config/featureFlags";
import { isConnectionValidationAccount } from "@/config/connectionValidation";
import { useLibraryIdentity } from "@/hooks/useLibraryIdentity";

/** Only the Connections/email UI participates in this controlled rollout. */
export function useEmailConnectionAccess() {
  const identity = useLibraryIdentity();
  const validationAccount = isConnectionValidationAccount(identity);
  return {
    gmailEnabled: FEATURE_FLAGS.GMAIL_ENABLED || validationAccount,
    outlookEnabled: FEATURE_FLAGS.OUTLOOK_MAIL_ENABLED || validationAccount,
    // Account changes discard mailbox results, drafts and in-flight component state.
    identityKey: identity.ready && !identity.error
      ? identity.userId ?? "signed-out"
      : "unresolved",
  };
}
